import AppRoute from "models/AppRoute"
import { ArticleTypeBasic, ManufacturerType } from "config/constants"
import { Guid } from "@/types"

interface IArticleCreateRouteParams {
    articleTypeBasic: ArticleTypeBasic
    manufacturerType: ManufacturerType
}

interface IArticleCreateRouteQueryParams {
    assetId?: Guid
}

const ArticleCreateRoute = new AppRoute<IArticleCreateRouteParams, IArticleCreateRouteQueryParams>({
    route: "/article/create/:articleTypeBasic/:manufacturerType",
    navbar: true,
    authRequired: true,
})

export default ArticleCreateRoute
